export default __webpack_public_path__ + "static/media/player-team.b3ed56d4.svg";